import type { Site } from '../../shared/contract/orgs.js';
import { elChecked, elValue } from '../lib/dom.js';
import { showToast } from '../lib/toast.js';
import { api } from './api.js';
import { loadSettings } from './loaders.js';
import { me, siteDialog } from './state.js';

/** Open the Sites dialog to add a site (`null`) or edit one (HS2-DE4RP1). */
export function openSiteDialog(siteId: string | null): void {
  siteDialog.value = { siteId, error: '' };
}

export function closeSiteDialog(): void {
  siteDialog.value = null;
}

/** Save the open Sites dialog; a failure stays in the dialog with its message. */
export async function saveSite(root: HTMLElement): Promise<void> {
  const open = siteDialog.value;
  const orgId = me.value?.organizationId;
  if (open === null || orgId === null || orgId === undefined) return;
  const dialog = root.querySelector('[data-action="site-dialog"]');
  if (dialog === null) return;
  const body: Site = {
    name: elValue(dialog.querySelector('[name="site-name"]')).trim(),
    location: elValue(dialog.querySelector('[name="site-location"]')).trim(),
    isDefault: elChecked(dialog.querySelector('[name="site-default"]')),
  };
  if (body.name === '') {
    siteDialog.value = { ...open, error: 'Enter a site name.' };
    return;
  }
  const res = open.siteId === null ? await api.createSite(orgId, body) : await api.updateSite(orgId, open.siteId, body);
  if (!res.ok) {
    siteDialog.value = { ...open, error: res.error ?? 'Could not save the site.' };
    return;
  }
  siteDialog.value = null;
  showToast(open.siteId === null ? `Site “${body.name}” added.` : 'Site saved.');
  await loadSettings();
}
